import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";
import anim_line from "../../img/winter.png"
import { useParams ,useHistory, useRouteMatch,} from "react-router-dom";

import LoadingButton from "../../Loading/LoadingButton";
import { useSelector } from "react-redux";
import {Activity, Plus } from 'lucide-react';
import Snackbar from "../../../Snackbar";
import { createCourseByAdminV2 } from "../../../store/actions/CreateCourse/createCourseByAdmin";
import AppMenuCardBlue from "../AppCards/AppMenuCardBlue";
import { getProductByProductId } from "../../../api";
import AreYouSurePopUp from "../../Create/CreateContent/ContentPopUp/AreYouSurePopUp";
import AppMenuCardBlueBG from "../AppCards/AppMenuCardBlueBG";
import NextStepCardPopUp from "../AppCards/NextStepCardPopUp";
import SkillsProductAddMore from "./SkillsProductAddMore";
import SettingsToggleCard from "../../UI/SettingsToggleCard";
import AppearanceToggleCard from "../../UI/AppearanceToggleCard";
import AppMenuCardBlueBGTwo from "../AppCards/AppMenuCardBlueBGTwo";
const AppearanceProduct = ({setActiveCardOverview,baseUrl})=>{
  const {courseId} = useParams();
  const {url}=useRouteMatch();
  const history = useHistory();
   const dispatch = useDispatch();

   const [snackbarVisible, setSnackbarVisible] = useState(false);
   const [snackbarColor, setSnackbarColor] = useState("#958FDA");
   const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
 
  const [goNextPopUp, setGoNextPopUp] =useState(false);
 
 const showSnackbar = () => {
   setSnackbarVisible(true);
 };

 const hideSnackbar = () => {
   setSnackbarVisible(false);
 };
 const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
  {
    
    dispatch({type: "CURSOR",payload:true  });

    dispatch({type: "CURSORTEXT",payload:CursorText})
    dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
    dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
  }
   
  const handleMouseLeave = () => {
    
    dispatch({type: "CURSOR",payload:false})

    dispatch({type: "CURSORTEXT",payload:""})

    dispatch({type: "CURSORTEXTBG",payload:""})
    dispatch({type: "CURSORTEXTCOLOR",payload:""})
  

}
  
 const token = useSelector((state)=>state?.course?.course?.token);
 const currentToken = useSelector((state)=>state?.user?.user?.token);
 const user_email = useSelector((state)=>state?.user?.user?.user_email
);

const postIdCourse = useSelector((state)=>state?.course?.course?.postId);

const courseData = useSelector((state)=>state?.course?.course);
const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
const appId = useSelector((state)=>state?.app?.app?.ID);
const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);

 const [loader , setLoader] =useState({status:false});
 const [seofriendlyURL, setSeofriendlyURL] = useState(courseData?.seofriendlyURL?courseData?.seofriendlyURL:"");
 const [seoPageTitle, setSeoPageTitle] = useState(courseData?.seoPageTitle?courseData?.seoPageTitle:"");
 
 const [productID, setProductID] = useState(courseData?.ID?courseData?.ID:"");
 const [editType, setEditType] = useState(courseData?.ID?"seo":"");

 const [hideAuthors, setHideAuthors] = useState(courseData?.hideAuthors?JSON.parse(courseData?.hideAuthors):false);
 const [hidePrice, setHidePrice] = useState(courseData?.hidePrice?JSON.parse(courseData?.hidePrice):false);
 const [hideReviews, setHideReviews] = useState(courseData?.hideReviews?JSON.parse(courseData?.hideReviews):false);
 const [hideTotalEnrolled, setHideTotalEnrolled] = useState(courseData?.hideTotalEnrolled?JSON.parse(courseData?.hideTotalEnrolled):false);
 const [hideValidity, setHideValidity] = useState(courseData?.hideValidity?JSON.parse(courseData?.hideValidity):false);
 const [hideLastUpdated, setHideLastUpdated] = useState(courseData?.hideLastUpdated?JSON.parse(courseData?.hideLastUpdated):false);
 const [hideMaxAllowedStudents, setHideMaxAllowedStudents] = useState(courseData?.hideMaxAllowedStudents?JSON.parse(courseData?.hideMaxAllowedStudents):false);
  let TypeTitle= courseData?.ID?courseData?.type=='course'?"Course":
  courseData?.type=='batch'?"Batch":
  courseData?.type=="testSeries"?"Test Series":
  courseData?.type=="homeTutor"?"Home Tutor Offering":
  courseData?.type=="bundle"?"Bundle":
courseData?.type=="digitalProduct"?"Digital Product":"Course":"Course";
 const [animate, setAnimate] = useState(false);

 useEffect(() => {
   // Trigger the animation after a delay (e.g., 500ms)
   const timer = setTimeout(() => {
    setAnimate(true);  
  }, 100);

   return () => clearTimeout(timer); // Cleanup on unmount
 }, []);
useEffect(()=>{
  setActiveCardOverview(true);
  
  // setCourseTitleData();
},[])

    
   

  const handleCreateProduct=(editVal,state)=>{
  let sendObject;
  if(editVal=="hideAuthors"){
    sendObject ={hideAuthors:JSON.stringify(state),
        type:courseData?.ID?courseData?.type:"course",
      postParent:"0" ,userEmail:user_email?user_email:"",
      currentToken:currentToken?currentToken:"",
      editType:editVal,postId:productID,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
   }
   if(editVal=="hidePrice"){
    sendObject ={hidePrice:JSON.stringify(state),
        type:courseData?.ID?courseData?.type:"course",
      postParent:"0" ,userEmail:user_email?user_email:"",
      currentToken:currentToken?currentToken:"",
      editType:editVal,postId:productID,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
   }if(editVal=="hideReviews"){
    sendObject ={hideReviews:JSON.stringify(state),
        type:courseData?.ID?courseData?.type:"course",
      postParent:"0" ,userEmail:user_email?user_email:"",
      currentToken:currentToken?currentToken:"",
      editType:editVal,postId:productID,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
   }
   if(editVal=="hideTotalEnrolled"){
    sendObject ={hideTotalEnrolled:JSON.stringify(state),
        type:courseData?.ID?courseData?.type:"course",
      postParent:"0" ,userEmail:user_email?user_email:"",
      currentToken:currentToken?currentToken:"",
      editType:editVal,postId:productID,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
   }
   if(editVal=="hideValidity"){
    sendObject ={hideValidity:JSON.stringify(state),
        type:courseData?.ID?courseData?.type:"course",
      postParent:"0" ,userEmail:user_email?user_email:"",
      currentToken:currentToken?currentToken:"",
      editType:editVal,postId:productID,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
   }
   if(editVal=="hideLastUpdated"){
    sendObject ={hideLastUpdated:JSON.stringify(state),
        type:courseData?.ID?courseData?.type:"course",
      postParent:"0" ,userEmail:user_email?user_email:"",
      currentToken:currentToken?currentToken:"",
      editType:editVal,postId:productID,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
   }
   if(editVal=="hideMaxAllowedStudents"){
    sendObject ={hideMaxAllowedStudents:JSON.stringify(state),
        type:courseData?.ID?courseData?.type:"course",
      postParent:"0" ,userEmail:user_email?user_email:"",
      currentToken:currentToken?currentToken:"",
      editType:editVal,postId:productID,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
   }
   
  
  setLoader({status:true});
  
    const apiData = dispatch(createCourseByAdminV2(sendObject));
    /* get response as Promise   */
    apiData.then(response => {
      if(response){
        if(response?.course){
          
      setResponseMessage(response?.message);
      setSnackbarColor("rgba(144, 202, 249,1)");
    
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
    setProductID(response?.course?.postId);
   
   setGoNextPopUp(true);
  },1000)
     }else{
      setResponseMessage("Something Went Wrong...");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
     }
        
     
     if(response?.logout){
     
      setResponseMessage("You are Logged Out!!!");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
      setTimeout(()=>{
        dispatch({type:"LOGOUT"});
  
      },3000)
      
    }
  /* resetting Login input Fields */
  
      }else{
        setResponseMessage("Something Went Wrong...");
        
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)    }
  
    }).catch(error => {
   
      //popup of error Info
      setResponseMessage("Something Went Wrong...");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
      console.error(error);
    });
   
    }
    
    return <>
    
{<>
  {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor} onClose={hideSnackbar} />
      )}

<div  className="ikcraft_login-signup-card-outerj"><div  className=" contentPageScroller " style={{background:"#fff",borderRadius:"25px"}}>
<div className="gridFiftyFixed"style={{
       
    }}>
<div >
 <AppMenuCardBlueBGTwo  activeCard={""} icon={5} title ="Settings " onClickPopup={
          ()=>{ history.push(`${baseUrl}/settings`) 
          }}  /></div>
<div style={{  transform: animate ? 'scale(1)' : 'scale(.91)',
        opacity: animate ? 1 : 0,
        transition: 'transform 1s ease, opacity 1s ease',}}><AppMenuCardBlueBG activeCard={""} icon={1} title ="Appearance " onClickPopup={
        ()=>{ history.push(`${baseUrl}/appearance`)
        }}  /></div>    
 
 </div>   <div  className=" ">

      <h1  style={{"textAlign":"center", transform: animate ? 'scale(1)' : 'scale(.91)',
        opacity: animate ? 1 : 0,
        transition: 'transform 1s ease, opacity 1s ease',
            }}>   Set {TypeTitle} Page <span className="coloredTextV1" >Appearance</span> </h1>

<div className="gridForWhatsNextAfterYT" style={{alignContent:"center",textAlign:"center",
        
      }}>
      
      
       
       
<AppearanceToggleCard animEffect={100} handleCourseSettings={(state)=>handleCreateProduct("hideAuthors",state)} myCardState={hideAuthors} setMyCardState={setHideAuthors} progress={25} icon={6}  title="Hide Authors"  cursorAlign="" cursorTextVal=""/>


 
       
<AppearanceToggleCard animEffect={200} handleCourseSettings={(state)=>handleCreateProduct("hidePrice",state)} myCardState={hidePrice} setMyCardState={setHidePrice} progress={35} icon={3}  title="Hide Prices"  cursorAlign="" cursorTextVal=""/>


       
<AppearanceToggleCard animEffect={300} handleCourseSettings={(state)=>handleCreateProduct("hideReviews",state)} myCardState={hideReviews} setMyCardState={setHideReviews} progress={45} icon={2}  title="Hide Reviews"  cursorAlign="" cursorTextVal=""/>


       
<AppearanceToggleCard animEffect={400} handleCourseSettings={(state)=>handleCreateProduct("hideTotalEnrolled",state)} myCardState={hideTotalEnrolled} setMyCardState={setHideTotalEnrolled} progress={55} icon={1}  title="Hide Total Enrolled"  cursorAlign="" cursorTextVal=""/>


       
<AppearanceToggleCard animEffect={500} handleCourseSettings={(state)=>handleCreateProduct("hideValidity",state)} myCardState={hideValidity} setMyCardState={setHideValidity} progress={65} icon={7}  title="Hide Validity"  cursorAlign="" cursorTextVal=""/>


       
<AppearanceToggleCard animEffect={600} handleCourseSettings={(state)=>handleCreateProduct("hideLastUpdated",state)} myCardState={hideLastUpdated} setMyCardState={setHideLastUpdated} progress={75} icon={4}  title="Hide Last Update"  cursorAlign="" cursorTextVal=""/>


       
<AppearanceToggleCard animEffect={700} handleCourseSettings={(state)=>handleCreateProduct("hideMaxAllowedStudents",state)} myCardState={hideMaxAllowedStudents} setMyCardState={setHideMaxAllowedStudents} progress={85} icon={5}  title="Hide Max Students"  cursorAlign="" cursorTextVal=""/>


 


   </div>
    </div> 
   <div className="CreateCourseStepsOuterBottom" style={{padding:'15px',fontSize:'12px',marginBottom:'10px'}}>
    <div  >   </div>
  
    
    <button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>{history.push(`${baseUrl}/seo`)}}  className="CreateCourseStepsOuterRightButtonBack"  type="submit"
     id="signupBtn"> Back </button>

 <button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>{history.push(`${baseUrl}/settings`)}} style={{width:"140px",height:"55px"}} className="CreateCourseStepsOuterRightButton"  type="submit"
     id="signupBtn"> {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":productID?"Go Next":"Go Next"} </button>
     
  </div>
  
    <div  className="ikcraft_login-input-card">
   
      
  </div>

  <div> 
    
    
    
    
  </div>
 </div>
    
 <div></div>
 

  </div>
</>}
    </>

}

export default AppearanceProduct;

